// @ts-nocheck
import * as React from 'react';
// Avatar — circular avatar with gradient background and initials.

export default function Avatar({ p, size = 36 }) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: 999,
        background: p.avatarBg,
        color: "#1f1300",
        display: "grid",
        placeItems: "center",
        fontWeight: 700,
        fontSize: size * 0.36,
        letterSpacing: "-0.02em",
        flexShrink: 0,
      }}
    >
      {p.initials}
    </div>
  );
}
